import { nortadaLogger } from '../components/common/logger';

const queryTypesMapperToString = (queryType: string): string => {
  const queryTypesTranslation: Record<string, string> = {
    NAME_AND_MSISDN: 'Name & Phone number',
    NAME_AND_BANK_ACCOUNT: 'Name & Bank Account',
    MSISDN_AND_DATE_OF_BIRTH: 'Phone number & Date of Birth',
    BVN_AND_NAME_AND_DATE_OF_BIRTH: 'BVN & Name & Date of Birth'
  };

  return queryTypesTranslation[queryType] ?? nortadaLogger.critical(`${queryType} is unsupported query type.`);
};

export default queryTypesMapperToString;
